import { render, staticRenderFns } from "./PopUpEditor.vue?vue&type=template&id=3c513e10&scoped=true"
import script from "./PopUpEditor.vue?vue&type=script&lang=js"
export * from "./PopUpEditor.vue?vue&type=script&lang=js"
import style0 from "./PopUpEditor.vue?vue&type=style&index=0&lang=css"
import style1 from "./PopUpEditor.vue?vue&type=style&index=1&id=3c513e10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c513e10",
  null
  
)

export default component.exports